export interface HotJarSettings {
  hjid: number
  hjsv: number
}

export class HotJar {
  private hj?: any
  private hjSettings: HotJarSettings
  private active: boolean
  private promise?: Promise<any>

  constructor(settings: HotJarSettings, active?: boolean) {
    this.hjSettings = settings
    this.active = active!
  }

  public pageView(eventName: string, params: object) {
    return new Promise((resolve, reject) => {
      this._load()
        .then(() => {
          this.hj('stateChange', window.location.pathname)
          resolve(window.location.pathname)
        })
        .catch(err => {
          console.error('Error loading HotJar')
        })
    })
  }

  private _load() {
    return (
      this.promise ||
      (this.promise = new Promise<void>((resolve, reject) => {
        if (this.hj) {
          resolve()
        } else {
          const w = window as any
          w.hj =
            w.hj ||
            // tslint:disable-next-line
            function() {
              ;(w.hj.q = w.hj.q || []).push(arguments)
            }
          w._hjSettings = this.hjSettings

          const script = document.createElement('script')
          script.async = true

          script.onload = () => {
            this.hj = w.hj
            resolve()
          }

          script.onerror = error => {
            reject(error)
          }

          script.src =
            `https://static.hotjar.com/c/hotjar-${this.hjSettings.hjid}.js?` +
            `sv=${this.hjSettings.hjsv}`
          document.head.appendChild(script)
        }
      }))
    )
  }
}
